import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mustChange, setMustChange] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("nilo_token");
    if (!t) return setLoading(false);
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        setMustChange(!!r.data.must_change_password);
      })
      .catch(() => localStorage.removeItem("nilo_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (dni, password) => {
    const { data } = await api.post("/auth/login", { dni, password });
    localStorage.setItem("nilo_token", data.token);
    setUser(data.user);
    setMustChange(data.must_change_password);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("nilo_token");
    setUser(null);
    setMustChange(false);
  };

  return (
    <Ctx.Provider value={{ user, loading, login, logout, mustChange, setMustChange }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
